import sendGaComponentEvent from '@gcloud-npm/utils.metrics.send-ga-component-event';

export const doScroll = (selectRef, selectIndex) => {
  const children = selectRef.current?.children;
  const focusedItem = children && children[selectIndex];
  if (!focusedItem) return;

  const containerHeight = selectRef.current.clientHeight;

  const itemOffsetTop = focusedItem.offsetTop;
  const itemHeight = focusedItem.clientHeight;

  const scrollTo = Math.max(0, itemOffsetTop + itemHeight - containerHeight);

  selectRef.current.scrollTo({
    top: scrollTo,
  });
};

export const sendTaggingInfo = (taggingInfo, eventType) => {
  const finalTaggingInfo = {
    ...taggingInfo,
    eventType,
  };
  try {
    const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
    const isFrontApp = typeof window !== 'undefined';
    const isMetricsDevEnable =
      isFrontApp && window.location.search.indexOf('metrics') > -1;
    if ((isFrontApp && currentEnv !== 'dev') || isMetricsDevEnable) {
      sendGaComponentEvent(finalTaggingInfo);
    }
  } catch (err) {
    throw err;
  }
};

export const SELECT_STYLE = {
  BASIC: '-basic',
  AUTOCOMPLETE: '-autocomplete',
};

export const SEARCHING_TEXT = 'Buscando resultados';
export const NO_OPTIONS_TEXT = 'No hay resultados';
